var _style, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStart = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "startPin",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 47.3",
    style: {
      enableBackground: "new 0 0 28 47.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.start-pin-st0{opacity:0.42;}\n\t.start-pin-st1{fill:#FFFFFF;}\n\t.start-pin-st2{fill:#FF9E00;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "start-pin-st0",
    cx: 14.8,
    cy: 35.1,
    r: 12.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "start-pin-st1",
    cx: 14,
    cy: 34.7,
    r: 11.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "start-pin-st2",
    d: "M12.9,40.8c0.1,0.2,0.2,0.3,0.4,0.5c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.5 l3.2-6.7c0.2-0.4,0.3-0.9,0.3-1.6c0-1.2-0.5-2.3-1.3-3.2c-0.8-0.8-1.8-1.3-3-1.3s-2.3,0.5-3.2,1.3c-0.9,1-1.4,2-1.4,3.2 c0,0.6,0.1,1.1,0.3,1.6L12.9,40.8z M12.4,30.9c0.5-0.4,1-0.6,1.6-0.6s1.1,0.2,1.6,0.7s0.7,1,0.7,1.6c0,0.6-0.3,1.1-0.8,1.6 s-1,0.7-1.6,0.7s-1.1-0.2-1.6-0.7s-0.7-1-0.7-1.6C11.8,31.9,11.9,31.4,12.4,30.9z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/start.ad4edb62.svg";
export { ForwardRef as ReactComponent };